import { useEffect, useRef } from 'react';
// Pont CRM : seules les fenêtres parentes CMS autorisées peuvent agir.
const CMS_ORIGINS = ['https://cms.amservices.eu', 'http://localhost:3000'];
let parentOrigin = null;
let selection = null;
const listeners = new Set();
try {
  const origin = new URL(document.referrer).origin;
  if (CMS_ORIGINS.includes(origin)) parentOrigin = origin;
} catch (_) {}
if (window.parent !== window) {
  window.addEventListener('keydown', event => {
    if (!parentOrigin || event.repeat || event.altKey || !(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 'k') return;
    event.preventDefault();
    window.parent.postMessage({ type: 'AMS_SEARCH_OPEN' }, parentOrigin);
  }, true);
  window.addEventListener('message', event => {
    if (event.source !== window.parent || !CMS_ORIGINS.includes(event.origin)) return;
    if (event.data?.type !== 'AMS_SEARCH_SELECT') return;
    parentOrigin = event.origin;
    if (typeof event.data.query !== 'string' || event.data.query.length > 260) return;
    if (selection?.nonce === event.data.nonce) return;
    selection = { query: event.data.query, id: String(event.data.id || ''), nonce: event.data.nonce, date: event.data.date, documentId: event.data.documentId, documentType: event.data.documentType };
        if (window.location.hostname === 'appel.amservices.eu' && ['/depannage', '/bureau', '/admin/archives'].includes(event.data.view) && window.location.pathname !== event.data.view) {
      window.history.pushState({}, '', event.data.view);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
    listeners.forEach(listener => listener(selection));
  });
  if (parentOrigin) window.parent.postMessage({ type: 'AMS_SEARCH_READY' }, parentOrigin);
}
export function onGlobalSearchSelection(listener) {
  listeners.add(listener);
  if (selection) listener(selection);
  return () => listeners.delete(listener);
}
export function useGlobalSearchSelection(callback) {
  const current = useRef(callback);
  current.current = callback;
  useEffect(() => onGlobalSearchSelection(value => current.current(value)), []);
}